fragment AttachmentFull on Attachment {
  path
  title
  type
  size
}
